Vue.component('ack-pac-dent-product-menu', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-pac-dent-product-menu',
	mounted() {},
	created() {
		if (this.menuItems && this.menuItems.length > 0) {
			this.activeItem = this.menuItems[0];
		}
	},
	props: {
		menuItems: {
			// :product-info
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('shop', ['productList']),

		carouselOptions() {
			const mobile_slide_to_show = 4;
			const mobile_slide_to_scroll = 3;
			const desktop_slide_to_show = 6;
			const desktop_slide_to_scroll = 6;

			let opt = {
				arrows: !this.isMobile,
				dots: false,
				infinite: false,
				slidesToShow: this.isMobile ? mobile_slide_to_show : desktop_slide_to_show,
				slidesToScroll: this.isMobile ? mobile_slide_to_scroll : desktop_slide_to_scroll,
				autoplay: false,
				speed: 200,
				autoplaySpeed: 0,
				cssEase: 'linear',
				//vertical: this.isMobile ? false : true,
				initialSlide: -1,
			};

			return opt;
		},
	},
	data() {
		return {
			activeItem: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		// ...Vuex.mapActions('shop', ['sayHi', 'closeAllMobileDropdowns']),
		onResinMenuItemClick(item) {
			this.$emit('resin-menu-item-click', item);
			this.activeItem = item;
		},
		onMenuItemClick(item) {
			this.$emit('resin-menu-item-click', item);
			this.activeItem = item;
		},
	},
	beforeDestroy() {},
	watch: {
		prop1: {
			handler() {},
			deep: false,
		},
	},
});
